module.exports = __webpack_public_path__ + "images/5099770f5b2d8baf4a0166aaa02eaa4b-Paradisecoast.jpg";